module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    ref: "figure"
  }, [(_vm.isSimpleLadder) ? _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.figureHeight
    }
  }, [_c('rect', {
    attrs: {
      "x": 0,
      "y": 0,
      "width": _vm.width,
      "height": _vm.figureHeight
    }
  }), _vm._v(" "), _vm._l(((_vm.value.height - _vm.value.topPawl - _vm.value.bottomPawl) / _vm.value.pawlInterval + 1), function(i) {
    return _c('circle', {
      key: i,
      attrs: {
        "cx": _vm.width / 2,
        "cy": ((_vm.value.topPawl + (i - 1) * _vm.value.pawlInterval) / _vm.value.height) * _vm.figureHeight,
        "r": _vm.figureHeight / 200
      }
    })
  })], 2) : _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.figureHeight
    }
  }, [_c('rect', {
    attrs: {
      "x": 0,
      "y": 0,
      "width": _vm.width,
      "height": _vm.figureHeight
    }
  }), _vm._v(" "), _vm._l(((_vm.value.height - _vm.value.topPawl - _vm.value.bottomPawl) / _vm.value.pawlInterval + 1), function(i) {
    return _c('circle', {
      key: i,
      attrs: {
        "cx": (_vm.width * 3) / 4 / 2,
        "cy": ((_vm.value.topPawl + (i - 1) * _vm.value.pawlInterval) / _vm.value.height) * _vm.figureHeight,
        "r": _vm.figureHeight / 200
      }
    })
  }), _vm._v(" "), _vm._l(((_vm.value.height - _vm.value.topPawl - _vm.value.bottomPawl) / _vm.value.pawlInterval + 1), function(i) {
    return _c('circle', {
      key: i,
      attrs: {
        "cx": (_vm.width * 3) / 4 / 2 + _vm.width / 4,
        "cy": ((_vm.value.topPawl + (i - 1) * _vm.value.pawlInterval) / _vm.value.height) * _vm.figureHeight,
        "r": _vm.figureHeight / 200
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56069792","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/catalog/ladder-preview.vue
// module id = 3193
// module chunks = 0